// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InstanceUserRead } from "./InstanceUserRead";
import {
  InstanceUserReadFromJSON,
  InstanceUserReadFromJSONTyped,
  InstanceUserReadToJSON,
  InstanceUserReadToJSONTyped,
} from "./InstanceUserRead";

/**
 *
 * @export
 * @interface PageInstanceUserRead
 */
export interface PageInstanceUserRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<InstanceUserRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageInstanceUserRead interface.
 */
export function instanceOfPageInstanceUserRead(value: object): value is PageInstanceUserRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageInstanceUserReadFromJSON(json: any): PageInstanceUserRead {
  return PageInstanceUserReadFromJSONTyped(json, false);
}

export function PageInstanceUserReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageInstanceUserRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(InstanceUserReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageInstanceUserReadToJSON(json: any): PageInstanceUserRead {
  return PageInstanceUserReadToJSONTyped(json, false);
}

export function PageInstanceUserReadToJSONTyped(
  value?: PageInstanceUserRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(InstanceUserReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
